"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePpbAppleCampaignNamesResponseSchema = exports.UpdatePpbAppleCampaignNamesBodySchema = exports.ListPpbAppleCampaignNamesQuerySchema = exports.ListPpbAppleCampaignNamesResponseSchema = exports.UpdateAppleProductPageBrowseRegionBodySchema = exports.CreateAppleProductPageBrowseRegionBodySchema = exports.ListAppleProductPageBrowseRegionResponseSchema = exports.GetAppleProductPageBrowseRegionQuerySchema = exports.UpdateAppleProductPageBrowseRegionResponseSchema = exports.CreateAppleProductPageBrowseRegionResponseSchema = exports.GetAppleProductPageBrowseRegionResponseSchema = exports.AppleProductPageBrowseRegionResponseSchema = exports.AppleProductPageBrowseRegionFields = exports.ListAppleProductPageBrowseChannelResponseSchema = exports.ListAppleProductPageBrowseChannelQuerySchema = exports.UpdateAppleProductPageBrowseChannelResponseSchema = exports.CreateAppleProductPageBrowseChannelResponseSchema = exports.GetAppleProductPageBrowseChannelResponseSchema = exports.AppleProductPageBrowseChannelResponseSchema = exports.AppleProductPageBrowseChannelFields = exports.UpdateAppleProductPageBrowseChannelBodySchema = exports.CreateAppleProductPageBrowseChannelBodySchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("./common");
/**
 * Channel API Types
 */
exports.CreateAppleProductPageBrowseChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleChannelFields,
});
exports.UpdateAppleProductPageBrowseChannelBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleChannelFields,
});
exports.AppleProductPageBrowseChannelFields = {
    ...common_1.AppleChannelIdFields,
    ...core_1.ModelMetaFields,
    ...common_1.CreateAppleChannelFields,
    structure: ruby_1.ChannelStructureSchema,
};
exports.AppleProductPageBrowseChannelResponseSchema = (0, core_1.StrictObject)(exports.AppleProductPageBrowseChannelFields);
exports.GetAppleProductPageBrowseChannelResponseSchema = exports.AppleProductPageBrowseChannelResponseSchema;
exports.CreateAppleProductPageBrowseChannelResponseSchema = exports.AppleProductPageBrowseChannelResponseSchema;
exports.UpdateAppleProductPageBrowseChannelResponseSchema = exports.AppleProductPageBrowseChannelResponseSchema;
exports.ListAppleProductPageBrowseChannelQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    campaignId: typebox_1.Type.Optional(core_1.IdSchema),
    status: typebox_1.Type.Optional(typebox_1.Type.Array(ruby_1.AppleChannelStatusSchema)),
});
exports.ListAppleProductPageBrowseChannelResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleProductPageBrowseChannelResponseSchema);
/**
 * Channel region API Types
 */
exports.AppleProductPageBrowseRegionFields = {
    ...core_1.ModelMetaFields,
    budgetWeighting: core_1.WeightingSchema,
    defaultBidAmount: typebox_1.Type.Optional(core_1.MoneySchema),
    status: ruby_1.AppleChannelRegionStatusSchema,
    country: core_1.CountrySchema,
    cpdGoal: typebox_1.Type.Optional(core_1.MoneySchema),
    apple: typebox_1.Type.Optional((0, core_1.StrictObject)({
        orgRef: ruby_1.AppleProxyOrgRefSchema,
        campaignRef: ruby_1.AppleProxyRefSchema,
    })),
};
exports.AppleProductPageBrowseRegionResponseSchema = (0, core_1.StrictObject)(exports.AppleProductPageBrowseRegionFields);
exports.GetAppleProductPageBrowseRegionResponseSchema = exports.AppleProductPageBrowseRegionResponseSchema;
exports.CreateAppleProductPageBrowseRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleProductPageBrowseRegionResponseSchema);
exports.UpdateAppleProductPageBrowseRegionResponseSchema = exports.AppleProductPageBrowseRegionResponseSchema;
exports.GetAppleProductPageBrowseRegionQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.ListAppleProductPageBrowseRegionResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.AppleProductPageBrowseRegionResponseSchema);
exports.CreateAppleProductPageBrowseRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.CreateAppleRegionCommonFields,
});
exports.UpdateAppleProductPageBrowseRegionBodySchema = (0, core_1.StrictObject)({
    ...common_1.UpdateAppleRegionCommonFields,
});
exports.ListPpbAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
exports.ListPpbAppleCampaignNamesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.UpdatePpbAppleCampaignNamesBodySchema = (0, core_1.StrictObject)({
    campaignNames: typebox_1.Type.Array(common_1.UpdateAppleCampaignNameSchema),
});
exports.UpdatePpbAppleCampaignNamesResponseSchema = (0, core_1.createUnsortedListResponseSchema)(common_1.AppleCampaignNameSchema);
